import React from 'react'

export default function Footer() {
  return (
    <footer>
      Всі права захищені &copy;
    </footer>
  )
}
